// src/utils/axiosConfig.js
import axios from 'axios';

// Configurer la base URL pour toutes les requêtes
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// Intercepteur de requête global
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur de réponse global
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Option 1: Rediriger automatiquement vers la page de connexion
      // window.location.href = '/login';
      
      // Option 2: Stocker l'information que l'utilisateur n'est plus authentifié
      localStorage.removeItem('token');
      localStorage.setItem('authError', 'true');
    }
    return Promise.reject(error);
  }
);

// Aucun export par défaut nécessaire - l'effet est global